<section id="app-lista-documentos-proposta" class="nova-pagina">
  <ng-container *ngIf="beneficiariosComDocumentos[0]?.documentos?.length > 0">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
  </ng-container>

  <div *ngFor="let beneficiario of beneficiariosComDocumentos" class="mb-5">
    <!--  nome + primeiro documento -->
    <div class="bloco-cabecalho-doc" *ngIf="beneficiario.documentos?.length > 0">
      <p class="mb-1 text-center">
        Beneficiário:
        <b>{{ beneficiario.nome }}</b>
      </p>

      <!--   PRIMEIRO DOCUMENTO -->
      <div class="documento mb-3 text-center">
        <p>
          <b>{{ beneficiario.documentos[0].description }}</b>
        </p>

        <!-- IMAGEM -->
        <img
          *ngIf="isImage(beneficiario.documentos[0].filePath)"
          [src]="beneficiario.documentos[0].filePath"
          class="image-wrapper"
          style="
            max-width: 70% !important;
            border: 1px solid #ccc;
            border-radius: 8px;
            display: block;
            margin: 0 auto;
          " />

        <!-- PDF -->
        <div *ngIf="isPdf(beneficiario.documentos[0].filePath)">
          <div *ngIf="beneficiario.documentos[0].carregando" class="text-info">
            <i class="fas fa-spinner fa-spin me-2"></i>
            Convertendo PDF...
          </div>

          <div *ngIf="beneficiario.documentos[0].paginasImagens">
            <div *ngFor="let pageImg of beneficiario.documentos[0].paginasImagens" class="mb-2">
              <img [src]="pageImg" class="img-render-pdf image-wrapper" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ RESTANTE DOS DOCUMENTOS -->
    <div *ngFor="let documento of beneficiario.documentos.slice(1)" class="mb-4 text-center documento">
      <p>
        <b>{{ documento.description }}</b>
      </p>

      <img
        *ngIf="isImage(documento.filePath)"
        [src]="documento.filePath"
        class="image-wrapper"
        style="max-width: 70% !important; border: 1px solid #ccc; border-radius: 8px; display: block; margin: 0 auto" />

      <div *ngIf="isPdf(documento.filePath)">
        <div *ngIf="documento.carregando" class="text-info">
          <i class="fas fa-spinner fa-spin me-2"></i>
          Convertendo PDF...
        </div>

        <div *ngIf="documento.paginasImagens">
          <div *ngFor="let pageImg of documento.paginasImagens" class="mb-2">
            <img [src]="pageImg" class="img-render-pdf image-wrapper" />
          </div>
        </div>
      </div>
    </div>

    <!-- fallback -->
    <ng-template #nenhumDoc>
      <p class="text-muted">Nenhum documento enviado.</p>
    </ng-template>
  </div>
</section>
